module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>'+
((__t=(t('collection::set:share:empty-share:headline')))==null?'':_.escape(__t))+
'</h1>\n<p>'+
((__t=(t('collection::set:share:empty-share:text')))==null?'':_.escape(__t))+
'</p>';
}
return __p;
};